/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Help20 = (props: SVGProps) => (
    <AccessibleSVG width={20} height={20} viewBox="0 0 20 20" {...props}>
        <path
            d="M10 1a9 9 0 11-.001 18.001A9 9 0 0110 1zm-.329 11.7a1.204 1.204 0 00-.844.336 1.132 1.132 0 00-.339.814 1.15 1.15 0 00.339.82c.105.104.23.184.373.243.144.058.3.087.471.087a1.209 1.209 0 00.841-.33 1.118 1.118 0 00.342-.82 1.12 1.12 0 00-.342-.814c-.108-.103-.234-.185-.377-.245s-.298-.09-.464-.09zm.31-7.7c-.301 0-.58.026-.838.077a3.957 3.957 0 00-.723.216c-.224.091-.434.198-.629.319s-.375.251-.541.39l.551.847c.095.166.238.25.43.25a.5.5 0 00.256-.075 8.97 8.97 0 01.3-.165 2.013 2.013 0 011.005-.238c.31 0 .553.08.73.238.177.16.265.374.265.643 0 .233-.052.433-.158.602-.105.168-.234.32-.386.457-.153.137-.316.264-.491.383s-.333.245-.474.377c-.142.132-.253.28-.333.444a.937.937 0 00-.068.575l.148 1.082h1.426l.188-.941a.761.761 0 01.219-.377 3.94 3.94 0 01.403-.34c.155-.114.319-.238.491-.373.173-.134.331-.293.474-.477.144-.184.263-.4.357-.649.094-.249.141-.544.141-.884 0-.359-.064-.685-.192-.979a2.086 2.086 0 00-.548-.753 2.431 2.431 0 00-.864-.48A3.556 3.556 0 009.98 5z"
            fill={vars.bdlGray50}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default Help20;
